import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import StoreListPage from './views/StoreList';
import Store360Page from './views/Store360';

export const storeRoutes = [
  {
    path: 'stores',
    name: '门店管理',
    icon: 'shop',
    children: [
      {
        index: true,
        element: <Navigate to="store-list" replace />,
      },
      {
        path: 'store-list',
        name: '门店列表',
        icon: 'unorderedList',
        element: <StoreListPage />,
      },
      {
        path: 'store-360',
        name: '门店 360',
        icon: 'profile',
        element: <Store360Page />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
